import React, { useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default function UtilisationFloorPanelDeskCharts() {
  useEffect(() => {
    // -------- Doughnut: Desk Utilisation --------
    var chartDesk = am4core.create("desk-utilisation", am4charts.PieChart);
    chartDesk.innerRadius = am4core.percent(70);
    chartDesk.data = [
      { category: "Used", value: 30 },
      { category: "Free", value: 70 },
    ];
    var pieSeriesDesk = chartDesk.series.push(new am4charts.PieSeries());
    pieSeriesDesk.dataFields.value = "value";
    pieSeriesDesk.dataFields.category = "category";
    pieSeriesDesk.labels.template.disabled = true;
    pieSeriesDesk.ticks.template.disabled = true;
    var deskLabel = chartDesk.seriesContainer.createChild(am4core.Label);
    deskLabel.text = "30%";
    deskLabel.horizontalCenter = "middle";
    deskLabel.verticalCenter = "middle";
    deskLabel.fontSize = 22; // bigger
    deskLabel.fill = am4core.color("#000");

    // -------- Doughnut: Sensor Utilisation --------
    var chartSensor = am4core.create("sensor-utilisation", am4charts.PieChart);
    chartSensor.innerRadius = am4core.percent(70);
    chartSensor.data = [
      { category: "Used", value: 40 },
      { category: "Free", value: 60 },
    ];
    var pieSeriesSensor = chartSensor.series.push(new am4charts.PieSeries());
    pieSeriesSensor.dataFields.value = "value";
    pieSeriesSensor.dataFields.category = "category";
    pieSeriesSensor.labels.template.disabled = true;
    pieSeriesSensor.ticks.template.disabled = true;
    var sensorLabel = chartSensor.seriesContainer.createChild(am4core.Label);
    sensorLabel.text = "40%";
    sensorLabel.horizontalCenter = "middle";
    sensorLabel.verticalCenter = "middle";
    sensorLabel.fontSize = 22; // bigger
    sensorLabel.fill = am4core.color("#000");

    // -------- Bar Chart: Utilisation by Hour --------
    var chartHour = am4core.create("utilisation-by-hour", am4charts.XYChart);
    chartHour.data = [
      { hour: "08:00", utilisation: 15 },
      { hour: "09:00", utilisation: 22 },
      { hour: "10:00", utilisation: 28 },
      { hour: "11:00", utilisation: 34 },
      { hour: "12:00", utilisation: 30 },
      { hour: "13:00", utilisation: 25 },
      { hour: "14:00", utilisation: 32 },
      { hour: "15:00", utilisation: 38 },
      { hour: "16:00", utilisation: 40 },
      { hour: "17:00", utilisation: 35 },
      { hour: "18:00", utilisation: 28 },
    ];
    var categoryAxisHour = chartHour.xAxes.push(new am4charts.CategoryAxis());
    categoryAxisHour.dataFields.category = "hour";
    categoryAxisHour.renderer.labels.template.fontSize = 10;
    categoryAxisHour.renderer.labels.template.rotation = 90;
    categoryAxisHour.renderer.grid.template.location = 0;
    categoryAxisHour.renderer.minGridDistance = 1; // force all labels
    var valueAxisHour = chartHour.yAxes.push(new am4charts.ValueAxis());
    valueAxisHour.renderer.labels.template.fontSize = 10;
    var seriesHour = chartHour.series.push(new am4charts.ColumnSeries());
    seriesHour.dataFields.valueY = "utilisation";
    seriesHour.dataFields.categoryX = "hour";
    seriesHour.name = "Utilisation";
    seriesHour.columns.template.tooltipText = "{categoryX}: [bold]{valueY}%[/]";

    // -------- Clustered Bar: Utilisation by Date/Hour --------
    var chartDate = am4core.create("utilisation-by-date", am4charts.XYChart);
    var clusteredData = [];
    var dates = [
      "01-Jul","02-Jul","03-Jul","04-Jul","05-Jul","06-Jul",
      "07-Jul","08-Jul","09-Jul","10-Jul","11-Jul","12-Jul","13-Jul","14-Jul"
    ];
    var hours = ["07:00","08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00"];
    for (var d = 0; d < dates.length; d++) {
      var isWeekend = (d === 5 || d === 6 || d === 12 || d === 13); // Sat/Sun
      for (var h = 0; h < hours.length; h++) {
        clusteredData.push({
          slot: dates[d] + " " + hours[h],
          survey: isWeekend ? 0 : Math.round(Math.random() * 40 + 20),
          sensor: isWeekend ? 0 : Math.round(Math.random() * 40 + 20),
        });
      }
    }
    chartDate.data = clusteredData;
    var categoryAxisDate = chartDate.xAxes.push(new am4charts.CategoryAxis());
    categoryAxisDate.dataFields.category = "slot";
    categoryAxisDate.renderer.labels.template.fontSize = 10;
    categoryAxisDate.renderer.labels.template.rotation = 90;
    categoryAxisDate.renderer.minGridDistance = 20;
    var valueAxisDate = chartDate.yAxes.push(new am4charts.ValueAxis());
    valueAxisDate.renderer.labels.template.fontSize = 10;
    var surveySeries = chartDate.series.push(new am4charts.ColumnSeries());
    surveySeries.dataFields.valueY = "survey";
    surveySeries.dataFields.categoryX = "slot";
    surveySeries.name = "Survey";
    surveySeries.columns.template.tooltipText = "{categoryX} (Survey): [bold]{valueY}%[/]";
    surveySeries.fill = am4core.color("#007bff");
    surveySeries.stroke = am4core.color("#007bff");
    var sensorSeries = chartDate.series.push(new am4charts.ColumnSeries());
    sensorSeries.dataFields.valueY = "sensor";
    sensorSeries.dataFields.categoryX = "slot";
    sensorSeries.name = "Sensor";
    sensorSeries.columns.template.tooltipText = "{categoryX} (Sensor): [bold]{valueY}%[/]";
    sensorSeries.fill = am4core.color("#28a745");
    sensorSeries.stroke = am4core.color("#28a745");

    chartDate.legend = null;

    return () => {
      chartDesk.dispose();
      chartSensor.dispose();
      chartHour.dispose();
      chartDate.dispose();
    };
  }, []);

  const titleStyle = {
    textAlign: "center",
    marginTop: "5px",
    fontSize: "12px",
    fontWeight: "bold",
    color: "#000",
  };

  return (
    <div style={{ display: "grid", gridTemplateRows: "1fr 1fr", gap: "20px" }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 2fr", gap: "20px" }}>
        <div>
          <div id="desk-utilisation" style={{ width: "100%", height: "20vh" }}></div>
          <div style={titleStyle}>Survey Utilisation</div>
        </div>
        <div>
          <div id="sensor-utilisation" style={{ width: "100%", height: "20vh" }}></div>
          <div style={titleStyle}>Sensor Utilisation</div>
        </div>
        <div>
          <div id="utilisation-by-hour" style={{ width: "100%", height: "23vh" }}></div>
          <div style={titleStyle}>Daily Profile</div>
        </div>
      </div>
      <div>
        <div id="utilisation-by-date" style={{ width: "100%", height: "26vh" }}></div>
        <div style={titleStyle}>Timeline</div>
      </div>
    </div>
  );
}





